import { render, staticRenderFns } from "./SellersHeaderV2.vue?vue&type=template&id=26c36f8c&scoped=true"
import script from "./SellersHeaderV2.vue?vue&type=script&lang=js"
export * from "./SellersHeaderV2.vue?vue&type=script&lang=js"
import style0 from "./SellersHeaderV2.vue?vue&type=style&index=0&id=26c36f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c36f8c",
  null
  
)

export default component.exports